import RoutePath from 'router/path';
import { PartnerFeatures } from 'router/routes/partner/features';

type RedirectRule = { condition: (features: PartnerFeatures) => boolean; path: string };

const pwcRedirectRules: RedirectRule[] = [
  { condition: (features) => features.pwc, path: RoutePath.Pwc.Orders.Root },
  { condition: (features) => features.cryptoPayout, path: RoutePath.CryptoPayout.Payouts.Root },
];

export const getPwcRedirectPath = (features: PartnerFeatures): string =>
  pwcRedirectRules.find((rule) => rule.condition(features))?.path ?? RoutePath.Pwc.Orders.Root;
